namespace Ir.Components.Workbook.Settings.ChartSettings {
    interface IViewModel {
        itemConfig: ReportConfig;
        reportSettingsVM: any,
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        legendPostitionParams: Ir.Components.Workbook.Settings.Items.LegendPositionSetting.ILegendPositionSettingParams;
        disableColorPerSerieSetting: KnockoutObservable<boolean>;
        colorThemeSelectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        chartTypesSelectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        axisLabelModeSelectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        axisLabelRotationNumberBox: DevExpress.ui.dxNumberBox.Properties;
        axisValueMarginNumberBox: DevExpress.ui.dxNumberBox.Properties;
        labelRotationAngle: DevExpress.ui.dxNumberBox.Properties;
        labelDecimalPlacesParams: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        labelUnitFormatParams: Ir.Components.Workbook.Settings.Items.UnitFormatSetting.IUnitFormatSettingParams;
        labelAlignParams: Ir.Components.Workbook.Settings.Items.TextAlignmentSetting.ITextAlignmentSettingParams;
        labelOverlappingSelectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        labelPositionSelectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        labelFontColorParams: Ir.Components.Workbook.Settings.Items.ColorSetting.IColorSettingParams;
        disabledLabelSettings: KnockoutComputed<boolean>;
        showSeriesLabel: KnockoutComputed<boolean>;
        chartNoAxis: KnockoutComputed<boolean>;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;

        self.activeTabItem = params.activeTabItem;
        self.config = params.config as WorkbookConfig;
        self.activeTabOrWidget = params.activeTabOrWidget;

        let itemConfig = self.activeTabOrWidget().drilldownManager.reportConfigForDrilldown;
        self.itemConfig = itemConfig;

        let chartWidget = self.activeTabOrWidget().drilldownManager.getActiveWidget() as ChartWidget;

        let disabledLabelSettings = ko.computed(function () {
            return !itemConfig.chartDefinition.labelVisibility();
        }) as any;
        self.disabledLabelSettings = disabledLabelSettings;

        self.showSeriesLabel = ko.computed(() => {
            return itemConfig.chartDefinition.chartType() !== ChartType.Polar && itemConfig.chartDefinition.chartType() !== ChartType.Radar &&
                itemConfig.chartDefinition.chartType() !== ChartType.RadarArea;
        });

        self.chartNoAxis = ko.computed(() => {
            return itemConfig.chartDefinition.chartType() === ChartType.Pie || itemConfig.chartDefinition.chartType() === ChartType.Donut ||
                itemConfig.chartDefinition.chartType() === ChartType.Polar || itemConfig.chartDefinition.chartType() === ChartType.Radar ||
                itemConfig.chartDefinition.chartType() === ChartType.RadarArea;
        });

        self.legendPostitionParams = { legendPosition: itemConfig.chartDefinition.legendPosition };

        self.disableColorPerSerieSetting = ko.computed(function () {
            if (!chartWidget.chartVM) {
                return true;
            }

            return !chartWidget.chartVM.allowColorPerSerie();
        });
        
        let axisLabelDisplayModeOptions = [
            { value: AxisLabelDisplayModeEnum.Standard, text: "Standard" },
            { value: AxisLabelDisplayModeEnum.Rotate, text: "Rotate" },
            { value: AxisLabelDisplayModeEnum.Stagger, text: "Stagger" },
        ];
        
        self.chartTypesSelectBoxOptions = getChartTypeConfig(itemConfig.chartDefinition.chartType);

        self.colorThemeSelectBoxOptions = {
            dataSource: ChartService.colorThemes,
            displayExpr: 'id',
            valueExpr: 'id',
            width: 250,
            height: 22,
            wrapItemText: true,
            value: itemConfig.chartDefinition.colorTheme,
            fieldTemplate: function (data, container) {
                var width = (100 / data.colors.length).toFixed(2);
                var content = `<div class="colorId"></div><span style="display: contents;">${data.id}</span><div class='colorThemes'>`;
                data.colors.forEach(color => {
                    content += `<div style="background: ${color}; width: ${width}%"></div>`;
                });
                content += "</div>"
                var $content = $(content);
                var $colorId = $($content[0]) as any;
                $colorId.dxTextBox({
                    value: data.id,
                    width: 18,
                    readOnly: true,
                    visible: false,
                });
                container.append($content);
            },
            itemTemplate: function (data) {
                var width = (100 / data.colors.length).toFixed(2);
                var content = `<span>${data.id}</span><div class='colorThemes'>`;
                data.colors.forEach(color => {
                    content += `<div style="background: ${color}; width: ${width}%"></div>`;
                });
                content += "</div>"

                return content;
            }
        };

        self.axisLabelModeSelectBoxOptions = {
            displayExpr: 'text',
            valueExpr: 'value',
            value: itemConfig.chartDefinition.axisLabelDisplayMode,
            items: axisLabelDisplayModeOptions,
            width: 80,
        };
        self.axisLabelRotationNumberBox = {
            format: '#0°',
            value: itemConfig.chartDefinition.axisLabelAngle as any,
            step: 15,
            showSpinButtons: isMobile() ? false : true,
            min: 0,
            max: 360,
            width: 80,
            disabled: disabledLabelSettings,
        };
        self.axisValueMarginNumberBox = {
            format: '#0%',
            value: itemConfig.chartDefinition.axisValueMargin as any,
            step: 0.01,
            showSpinButtons: isMobile() ? false : true,
            min: 0,
            max: 100,
            width: 80,
        };
        self.labelUnitFormatParams = {
            value: itemConfig.chartDefinition.labelFormat as any,
            disabled: disabledLabelSettings,
        };
        self.labelDecimalPlacesParams = {
            value: itemConfig.chartDefinition.labelDecimalPlaces,
            disabled: disabledLabelSettings,
        };
        self.labelAlignParams = {
            value: itemConfig.chartDefinition.labelAlign,
            disabled: disabledLabelSettings,
            visible: ko.computed(() => {
                return !self.chartNoAxis();
            })
        };
        self.labelRotationAngle = {
            format: '#0°',
            value: itemConfig.chartDefinition.labelRotationAngle as any,
            step: 45,
            showSpinButtons: isMobile() ? false : true,
            min: 0,
            max: 360,
            width: 100,
            disabled: disabledLabelSettings,
        };
        self.labelOverlappingSelectBoxOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.chartDefinition.labelOverlapping,
            items: [{ id: 'hide', text: 'Hide' }, { id: 'none', text: 'Show' }, { id: 'stack', text: 'Stack' }],
            width: 100,
            disabled: disabledLabelSettings
        };
        self.labelPositionSelectBoxOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.chartDefinition.labelPosition,
            items: [{ id: 'outside', text: 'Outside' }, { id: 'inside', text: 'Inside' }],
            width: 100,
            disabled: disabledLabelSettings
        };
        self.labelFontColorParams = {
            label: "Font Color",
            value: itemConfig.chartDefinition.labelFontColor,
            disabled: disabledLabelSettings
        };
    }
    function getChartTypes(forSerie?: boolean) {
        let lineType = new ChartTypeItemVM(ChartType.Line, "Content/charts/line.svg", "Line");
        let areaType =  new ChartTypeItemVM(ChartType.Area, "Content/charts/area.svg", "Area");
        let barType = new ChartTypeItemVM(ChartType.Bar, "Content/charts/bar.svg", "Bar");

        if (forSerie) {
            let chartTypes = [
                lineType,
                areaType,
                barType,
            ];
            return chartTypes;
        }
        else {
            let disableBubble = false; //chartVM.chartDefinition.yAxisFields.length < 3;
            let disableBubbleMessage = disableBubble ? "Need at least three Metrics" : "Define the X-Axis and Bubble Size in the Metrics";
            let disableScatter = false; // chartVM.chartDefinition.yAxisFields.length < 2;
            let disableScatterMessage = disableBubble ? "Need at least two Metrics" : "Define the X-Axis in the Metrics";

            let chartTypes = [
                lineType,
                new ChartTypeItemVM(ChartType.StackedArea, "Content/charts/stackedarea.svg", "Stacked Area"),
                areaType,
                barType,
                new ChartTypeItemVM(ChartType.StackedBar, "Content/charts/stackedbar.svg", "Stacked Bar"),
                new ChartTypeItemVM(ChartType.Donut, "Content/charts/donut.svg", "Donut"),
                new ChartTypeItemVM(ChartType.Pie, "Content/charts/pie.svg", "Pie"),
                new ChartTypeItemVM(ChartType.Polar, "Content/charts/polar.svg", "Polar"),
                new ChartTypeItemVM(ChartType.Radar, "Content/charts/radar.svg", "Radar"),
                new ChartTypeItemVM(ChartType.RadarArea, "Content/charts/radararea.svg", "Radar Area"),
                new ChartTypeItemVM(ChartType.HorizontalBar, "Content/charts/horizontalbar.svg", "Horizontal Bar"),
                new ChartTypeItemVM(ChartType.HorizontalBarStacked, "Content/charts/horizontalbarstacked.svg", "Horizontal Bar Stacked"),
                new ChartTypeItemVM(ChartType.Mixed, "Content/charts/mixed.svg", "Mixed", false, "Define the Chart Type in the Metrics"),
                new ChartTypeItemVM(ChartType.Scatter, "Content/charts/scatter.svg", "Scatter", disableScatter, disableScatterMessage),
                new ChartTypeItemVM(ChartType.Bubble, "Content/charts/bubble.svg", "Bubble", disableBubble, disableBubbleMessage)
            ];
            return chartTypes;
        }
    }

    export function getChartTypeConfig(value: KnockoutObservable<ChartType>, forSerie?: boolean) {
        return {
            displayExpr: 'title',
            valueExpr: 'chartType',
            value: value,
            items: getChartTypes(forSerie),
            width: forSerie ? 80 : 160,
            itemTemplate(data) {
                return `<div class='custom-item-charttypes' title="${data.tooltip()}"><img src='${data.image()}' /> ${data.title()}</div>`;
            },
            fieldTemplate(data, container) {
                const result = $(`<div class='custom-item-charttypes' title="${data?.tooltip()}"><img class='sb' src='${data?.image()}' /> <div class="tb"></div> </div>`);
                result
                    .find('.tb')
                    .dxTextBox({
                        value: data && data?.title(),
                        readOnly: true,
                        disabled: data?.disabled(),
                        hint: data?.tooltip(),
                    });
                container.append(result);
            },
        } as DevExpress.ui.dxSelectBox.Properties;
    }
}